import angular from 'angular';
import 'angular-ui-router';
import Filters from '../../filters/filters';
import template from '../creatives/variationsIndex.jade';
import ConfigsModule from '../../configs/configs';
import VariationsServices from '../../services/variationsServices.js';

export class VariationsIndexController {
  /* @ngInject */
  constructor($scope, $filter, $stateParams, currentGame, CampaignsResource, allVariationsAndCreativesRetrieved, variationRenderingUtilService) {
    this.$scope = $scope;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.stateParams = $stateParams;
    this.CampaignsResource = CampaignsResource;
    this.activeTab = null;
    this.allVariationsAndCreativesRetrieved = allVariationsAndCreativesRetrieved;
    this.variationRenderingUtilService = variationRenderingUtilService;
    this.gameCampaigns = [];
    this.currentGame = currentGame;
    this.setGameCampaigns(this.stateParams.id || this.stateParams.gameId);

    this.$scope.$watch('vm.activeTab', (newVal, oldVal) => {
      this.variationRenderingUtilService.variationTouchedCheck(oldVal, this.variations, this.pristineVariations);
      if (newVal !== null) {
        this.variationRenderingUtilService.loadVariation(newVal, this.variations, this.pristineVariations);
      }
    });

    this.allVariationsAndCreativesRetrieved.subscribe((pristineVariations) => {
      this.pristineVariations = pristineVariations;
    });
  }

  shouldShowVariation(index) {
    return this.activeTab === `tab-${(index+1)}`;
  }

  addNewVariation() {
    this.variations.push({
      name: this.translate('variation') + ' ' + (this.variations.length + 1),
      language: '--',
      countries: [],
      start_mode: 'immediate',
      end_mode: 'never',
      is_deleted: false
    });
    this.activeTab = 'tab-' + this.variations.length;
  }

  setGameCampaigns(gameId){
    this.CampaignsResource.one('active').get({game_id: gameId})
      .then(gameCampaigns => {
        this.gameCampaigns = gameCampaigns;
    })
  }
}

let VariationsIndexComponent = {
  template: () => { return template },
  controller: VariationsIndexController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    variations: '=',
    activeTab: '=',
    disableField: '='
  },
  bindToController: true
};

export default angular.module('app.components.campaigns.variationsIndex', [
  ConfigsModule.name,
  Filters.name,
  VariationsServices.name
])
  .component('variationsIndex', VariationsIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/variationsIndex.js
 **/